import styled from 'styled-components';
import { fastSpinAnimation } from 'components/styled/animations';

const SpinnerStyled = styled.div<{ $color: string }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 3px solid ${({ $color }) => $color};
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${fastSpinAnimation};
`;

type SpinnerProps = {
  color?: string;
  className?: string;
};

const Spinner = ({ color = 'currentColor', ...props }: SpinnerProps) => <SpinnerStyled {...props} $color={color} />;

export default Spinner;
